import React, { useEffect } from 'react';
import useBillingStore from '../../../services/useBillingStore';
import FullScreenLoader from '../../FullScreenLoader/FullScreenLoader';

const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return 'R$ 0,00';
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(amount);
};

const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('pt-BR').format(date);
};

const getStatusBadgeClass = (status) => {
  const classes = {
    active: 'badge-success',
    expired: 'badge-danger',
    cancelled: 'badge-warning',
    trial: 'badge-primary'
  };
  return classes[status?.toLowerCase()] || 'badge-default';
};

const UsageStat = ({ label, current, limit }) => {
  const percentage = limit === null ? 0 : Math.min((current / limit) * 100, 100);
  const limitText = limit === null ? 'ilimitado' : limit;

  return (
    <div className="usage-stat">
      <div className="usage-label">
        {label}: <strong>{current} / {limitText}</strong>
      </div>
      {limit !== null && (
        <div className="progress-bar">
          <div
            className="progress-fill"
            style={{ width: `${percentage}%` }}
          />
        </div>
      )}
    </div>
  );
};

const SubscriptionOverview = ({ onChangePlan }) => {
  const { subscription, loading, error, fetchSubscription } = useBillingStore();

  useEffect(() => {
    fetchSubscription();
  }, [fetchSubscription]);

  if (loading) {
    < FullScreenLoader message="Carregando Assinatura..." />
  }

  if (error) {
    return <div className="co-error">Erro ao carregar assinatura: {typeof error === 'string' ? error : 'Erro desconhecido'}</div>;
  }

  if (!subscription) {
    return <div className="co-hint">Nenhuma assinatura ativa encontrada.</div>;
  }

  return (
    <div className="subscription-card">
      <div className="subscription-header">
        <div>
          <h3>Assinatura Atual</h3>
          <span className={`badge ${getStatusBadgeClass(subscription.status)}`}>
            {subscription.status}
          </span>
        </div>
      </div>

      <div className="plan-details">
        <h2 className="plan-name">{subscription.plan_name}</h2>
        <div className="plan-price">
          {formatCurrency(subscription.price)} / {subscription.billing_cycle}
        </div>
        {subscription.next_billing_date && (
          <div className="next-billing">
            Próxima cobrança: {formatDate(subscription.next_billing_date)}
          </div>
        )}
      </div>

      {subscription.usage && subscription.limits && (
        <div className="usage-stats">
          <h4>Uso Atual</h4>
          <UsageStat
            label="Usuários"
            current={subscription.usage.users || 0}
            limit={subscription.limits.users}
          />
          <UsageStat
            label="Leads"
            current={subscription.usage.leads || 0}
            limit={subscription.limits.leads}
          />
          <UsageStat
            label="Automações"
            current={subscription.usage.automations || 0}
            limit={subscription.limits.automations}
          />
        </div>
      )}

      <button
        className="btn-primary"
        onClick={onChangePlan}
        style={{ marginTop: '1.5rem' }}
      >
        Alterar Plano
      </button>
    </div>
  );
};

export default SubscriptionOverview;
